import { TimeInterface } from '../../..';

export class TimeDto implements TimeInterface {
  hours: number;
  minutes: number;
}
